import React, { Component } from "react";
import { Route } from "react-router-dom";
import { Container } from "semantic-ui-react";
import ErrorBoundary from "../../ErrorBoundary";
import { LeadsTable } from "./LeadsTable";
import { Detail } from "./Detail";

export class Leads extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  render() {
    const { match } = this.props;

    return (
      <Container>
        <ErrorBoundary>
          <Route
            exact
            path={`${match.path}`}
            render={() => (
              <div>
                <h1>My Leads</h1>
                <LeadsTable />
              </div>
            )}
          />
          <Route
            path={`${match.path}/:leadId`}
            component={(props) => <Detail id={props.match.params.leadId} />}
          />
        </ErrorBoundary>
      </Container>
    );
  }
}
